/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-01-11 15:51:56
 * @LastEditors: JikeyChang
 * @LastEditTime: 2021-09-02 18:03:42
 * @Description: FileDescription
 */
import db from '@/api/db';

/**
 * [model 虚拟组织模块]
 * @type {Object}
 */
const model = {
  /**
   * 获取虚拟组织
   * @param {*} param
   */
  getVirtualList(param) {
    return db.post('/pmd/prodTeam/page', param);
  },
  /* 数据字典 */
  getDictListOld(param) {
    return db.post('/sys/dictionary/getMdmDictionaryList', param);
  },
  /* 数据字典 */
  getDictList(param) {
    return db.post('/sys/dictionary/list', param);
  },
  // 获取组织架构树
  getDeptUserAllListTreeVO(param) {
    return db.get('/umd/dept/makeDeptUserAllListTreeVO', param);
  },
  /* 查询teamlist */
  getUsersByCodeOld(param) {
    return db.post('/vom/teamUser/getTeam', param);
  },
  /* 查询teamlist */
  getUsersByCode(param) {
    return db.post('/pmd/teamUser/listByRoleType', param);
  },
  // 输入名字 自动联想
  listByNameLike(param) {
    const sendParam = {
      name: param.keyword,
    };
    return db.get('/umd/user/listUser', sendParam);
  },
  // 根据ids获取用户详情
  getUserListByIds(param) {
    return db.post('/umd/user/getUserVOListByIds', param);
  },
  // 更新角色成员
  updateTeamUserOld(param) {
    return db.post('/vom/teamUser/update', param);
  },
  // 更新角色成员
  updateTeamUser(param) {
    return db.post('/pmd/teamUser/batchModify', param);
  },
  getProductInfo(param) {
    return db.get('/pmd/productLineChild/getProdByType', param);
  },
  getUserList(param) {
    return db.get('/pmd/productLineChild/getUserList', param);
  },
  getTeamList(param) {
    return db.post('/pmd/teamUser/getTeamRole', param);
  },
  getProfessionList() {
    return db.get('/pmd/teamUser/getProfessional');
  },
  getTeamListData(param) {
    return db.post('/ipd/team/page', param);
  },
  getRoleListData(param) {
    return db.post('/ipd/role/page', param);
  },
  teamListSource(param) {
    return db.post('/ipd/team/list', param);
  },
  teamListSourceAll(param) {
    return db.post('/ipd/team/listAll', param);
  },
  getRoleSourcesFun(param) {
    return db.post('/ipd/role/list', param);
  },
  addTeamListFun(param) {
    if (param.id) {
      return db.post('/ipd/team/modify', param);
    }
    return db.post('/ipd/team/create', param);
  },
  addRoleList(param) {
    if (param.id) {
      return db.post('/ipd/role/modify', param);
    }
    return db.post('/ipd/role/create', param);
  },
  getTeamInfoFun(param) {
    return db.get('ipd/team/getVO', param);
  },
  getRoleInfo(param) {
    return db.get('ipd/role/getVO', param);
  },
  // 数据字典
  getDictionarySources(param) {
    return db.get('/sys/dictionary/getSysName', param);
  },
};

export default model;
